import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import Typography from "@material-ui/core/Typography";


const smallFont = {fontSize: 10};

export default function EntryTypeSelect({entryType, setEntryType}) {
    return (
        <RadioGroup
            row
            aria-label="entryType"
            name="entryType"
            value={entryType}
            onChange={(ev) => {
                setEntryType(ev.target.value);
            }}
        >
            <Grid container>
                <Grid item xs={2}>
                    <FormLabel><Typography style={smallFont}>Entry type:</Typography></FormLabel>
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel value="MARKET_ORDER" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>market</Typography>}/>
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel value="LIMIT_ORDER" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>limit</Typography>}/>
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel value="CANDLE_BREAK" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>candle break</Typography>}/>
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel value="BREAK" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>break price</Typography>}/>
                </Grid>
            </Grid>
        </RadioGroup>
    );
}